if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        formData.append(
          'quantity',
          this.querySelector('[name="quantity"]')?.value || 1,
        );
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
document.addEventListener('DOMContentLoaded', () => {
  class ProductWholesaleTab extends HTMLElement {
    constructor() {
      super();
      // Add your custom logic here
      if (!document.querySelector('#lb-volume-discount')) {
        this.style.display = 'none';
      }
      this.querySelectorAll('.product-wholesale-tab').forEach((el) => {
        el.addEventListener('click', (e) => {
          this.querySelectorAll('.product-wholesale-tab').forEach((el) => {
            el.classList.remove('active');
          });
          e.currentTarget.classList.add('active');
          if (e.currentTarget.dataset.tab == 'wholesale') {
            if (document.querySelector('product-wholesale-table').currentTier) {
              document
                .querySelector('product-wholesale-table')
                .classList.remove('hidden');
              document
                .querySelector('[id^="price"]')
                .classList.add('wholesale-price');
              document.querySelector(
                `#Quantity-${this.dataset.section}`,
              ).value = document.querySelector(
                'product-wholesale-table',
              ).currentTier.quantity;
              document
                .querySelector('.price-wholesale-total')
                .classList.remove('hidden');
              document
                .querySelector('.wholesale-text')
                .classList.remove('hidden');
            }
          } else {
            document
              .querySelector('product-wholesale-table')
              .classList.add('hidden');
            document
              .querySelector('[id^="price"]')
              .classList.remove('wholesale-price');
            document.querySelector(
              `#Quantity-${this.dataset.section}`,
            ).value = 1;
            document
              .querySelector(`#Quantity-${this.dataset.section}`)
              .setAttribute('min', 1);
            document
              .querySelector('.price-wholesale-total')
              .classList.add('hidden');
            document.querySelector('.wholesale-text').classList.add('hidden');
          }
        });
      });
    }
  }
  if (!customElements.get('product-wholesale-tab')) {
    customElements.define('product-wholesale-tab', ProductWholesaleTab);
  }
  class ProductWholeSaleTable extends HTMLElement {
    constructor() {
      super();
      if (!document.querySelector('#lb-volume-discount')) {
        this.style.display = 'none';
      }
      // Add your custom logic here
      let interval = setInterval(() => {
        if (document.querySelector('lb-volume-discount')) {
          clearInterval(interval);
          this.init();
        }
      }, 100);
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.variant) {
          this.dataset.price = data.variant.price / 100;
          this.init();
        }
      });
    }

    calcPrice(value) {
      let comparePrice = parseFloat(this.dataset.price) * 100;
      let price = comparePrice - (value * comparePrice) / 100;
      let percent = value;
      return `
        <div class="
    price price--large price--on-sale price--show-badge">
  <div class="price__container"><div class="price__sale">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>

        <span class="visually-hidden visually-hidden--inline">Sale price</span>
        <span class="price-item price-item--sale price-item--last">
           ${formatMoney(
             price,
             window.moneyFormats.money_format,
           )}  <span class=" twcss-font-light twcss-text-neutral-400 twcss-text-sm">/Cái</span>
        </span>
        <span>
        
        </span></div>
 
  </div></div>
        `;
    }
    calcTotalPrice(value, quantity) {
      quantity = parseInt(quantity);
      let comparePrice = parseFloat(this.dataset.price) * 100;
      let price = comparePrice - (value * comparePrice) / 100;
      return ` <div class="
      price price--large price--on-sale price--show-badge">
    <div class="price__container"><div class="price__sale">
          <span class="visually-hidden visually-hidden--inline">Regular price</span>
  
          <span class="visually-hidden visually-hidden--inline">Sale price</span>
          <span class="price-item price-item--sale price-item--last">
             ${formatMoney(price * quantity, window.moneyFormats.money_format)}
          </span>
          <span>
            <s class="price-item price-item--regular">
            ${formatMoney(
              comparePrice * quantity,
              window.moneyFormats.money_format,
            )}
            </s>
          </span></div>
     
  
    </div></div>`;
    }
    setCurrent(quantity) {
      let app = document.querySelector('lb-volume-discount');
      if (app.discount && app.discount.tiers.length > 0) {
        let currentTier = null;
        for (let i = 0; i < app.discount.tiers.length; i++) {
          if (app.discount.tiers[i].quantity <= quantity) {
            currentTier = app.discount.tiers[i];
          }
        }
        if (currentTier) {
          this.currentTier = currentTier;
          this.querySelector('.wholesale-cell.current').classList.remove(
            'current',
          );
          this.querySelector(
            `.wholesale-cell[data-quantity="${currentTier.quantity}"]`,
          ).classList.add('current');
          document.querySelector('.price-wholesale-container').innerHTML =
            this.calcPrice(this.currentTier.value);
          document.querySelector('.price-wholesale-total').innerHTML =
            this.calcTotalPrice(this.currentTier.value, quantity);
        }
      }
    }
    init() {
      let app = document.querySelector('lb-volume-discount');
      let price = parseFloat(this.dataset.price);

      if (
        app &&
        app.discount &&
        app.discount.tiers.length > 0 &&
        app.discount.type == 'PERCENTAGE'
      ) {
        this.currencyFormat = app.discount.currencyFormat;
        let columns = app.discount.tiers.map((tier, i) => {
          let discount = price - (tier.value * price) / 100;
          if (i == 0) {
            this.currentTier = {
              quantity: tier.quantity,
              value: tier.value,
            };
            document
              .querySelector(`#Quantity-${this.dataset.section}`)
              .setAttribute('min', tier.quantity);
          }
          if (
            i == app.discount.tiers.length - 1 &&
            document.querySelector('.product-wholesale__discount')
          ) {
            document.querySelector(
              '.product-wholesale__discount',
            ).innerHTML = `Tiết kiệm ${tier.value}%`;
          }
          return `<div class="twcss-grid twcss-gap-[1px] twcss-grow wholesale-cell ${
            i == 0 ? 'current' : ''
          }" data-quantity="${tier.quantity}" data-value="${
            tier.value
          }"><div class="twcss-p-2 twcss-min-w-[9rem] twcss-bg-neutral-100">${
            i == app.discount.tiers.length - 1
              ? `${tier.quantity}+`
              : tier.quantity
          }</div> <div class="twcss-p-2 twcss-min-w-[9rem]  twcss-bg-neutral-100">${formatMoney(
            discount * 100,
            window.moneyFormats.money_format,
          )}</div></div>`;
        });
        let table = `<div class="twcss-flex twcss-gap-[1px] twcss-max-w-full twcss-overflow-auto "><div class="twcss-grid twcss-gap-[1px]"><div class="twcss-p-2 twcss-min-w-[9rem]  twcss-bg-neutral-100"> Số lượng </div><div class="twcss-p-2 twcss-min-w-[9rem]  twcss-bg-neutral-100">Đơn giá</div></div> ${columns.join(
          '',
        )} </div>`;
        this.innerHTML = table;
        this.setCurrent(this.currentTier.quantity);

        document
          .querySelector(`#Quantity-${this.dataset.section}`)
          .addEventListener('change', (e) => {
            this.setCurrent(e.target.value);
          });
      }
    }
  }
  if (!customElements.get('product-wholesale-table')) {
    customElements.define('product-wholesale-table', ProductWholeSaleTable);
  }
});
